/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from 'recharts';
import styles from './revenueByOfferings.module.scss';
import dealByOfferings from '../../../../Assets/images/svg/dar_by_offerings.svg';
import CustomTooltip from './customTooltip';
import revenueOffers from './revenueOfferings.json';
import PropTypes from 'prop-types'

const RevenueByOfferings = ({ selectedValues }) => {
  const [chartData, setChartData] = useState([
    { label: 'App mod', value1: 50, value2: 10, name:'App mod' },
    { label: 'Data mod', value1: 30, value2: 20, name:'Data mod' },
    { label: 'Infra mod', value1: 30, value2: 30, name: 'Infra mod' },
  ]);

  const [labelNames] = useState([
    { id: 1, label: 'Total', color: "#A7B2FA" },
    { id: 2, label: 'Already won', color: "#9AEEC8" },
  ]);
const generateRandomValue =()=>{
  const randomValues = new Uint32Array(1);
window.crypto.getRandomValues(randomValues);
return randomValues[0] % 100
}
  useEffect(() => {
    window.scrollTo(0, 0);
    let verticalSelected = getSelectedValueById(1);
    switch (verticalSelected.toLowerCase()) {
      case 'app mod':
        if (revenueOffers?.appOptions) {
          const appOptionsMapped = revenueOffers.appOptions.map(option => ({
            label: option.label,  // Map 'label' to 'label' field in chart data
            value1: generateRandomValue(),  // Dummy data for value1
            value2: generateRandomValue(),   // Dummy data for value2
            name: option.name
          }));
          setChartData(appOptionsMapped);
        }
        break;

      case 'data mod':
        if (revenueOffers?.dataOptions) {
          const dataOptionsMapped = revenueOffers.dataOptions.map(option => ({
            label: option.label,  // Map 'label' to 'label' field in chart data
            value1: generateRandomValue(),  // Dummy data for value1
            value2: generateRandomValue(),   // Dummy data for value2
            name: option.name
          }));
          setChartData(dataOptionsMapped);
        }
        break;

      case 'infra mod':
        if (revenueOffers?.infraOptions) {
          const infraOptionsMapped = revenueOffers.infraOptions.map(option => ({
            label: option.label,  // Map 'label' to 'label' field in chart data
            value1: generateRandomValue(),  // Dummy data for value1
            value2: generateRandomValue(),   // Dummy data for value2
            name: option.name
          }));
          setChartData(infraOptionsMapped);
        }
        break;

      default:
        setChartData([
          { label: 'App mod', value1: 50, value2: 10, name:'App mod' },
          { label: 'Data mod', value1: 30, value2: 20, name:'Data mod' },
          { label: 'Infra mod', value1: 30, value2: 30, name: 'Infra mod' },
        ])
        break;
    }
  }, [selectedValues]);

  const getSelectedValueById = (id) => {
    const dropdown = selectedValues.find((d) => d.id === id);
    return dropdown ? dropdown.selectedValue : null;
  };

  return (
    <div className={styles['revenue-offerings-Container']} style={{ minHeight: '430px' }}>
      <div className={styles['revenue-offerings-heading-main']}>
        <img className={styles['revenue-offerings-heading-img']} src={dealByOfferings} alt="dealByOfferings" />
        <div className={styles['revenue-offerings-heading-text']}>By offerings</div>
      </div>
      <ResponsiveContainer width={'100%'} height={300} className={styles['revenue-offerings-chart']}>
        <BarChart
          data={chartData}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          barCategoryGap={0}  // Increase to create space between categories
          barGap={3}  // Adjust space between bars in the same category
        >
          <XAxis
            dataKey="label"
            stroke="#A4A4A4"
            tickMargin={10}
            strokeWidth={0.5}
            interval={0}  // Display every other label to prevent overlapping
            angle={0}
            textAnchor="middle"
            padding={{ left: 0, right: 0 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="value1" fill="#A7B2FA" barSize={15} radius={[10, 10, 0, 0]} />
          <Bar dataKey="value2" fill="#9AEEC8" barSize={15} radius={[10, 10, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <div className={styles['revenue-offerings-labels-main']}>
        {labelNames.map((item) => (
          <div className={styles['revenue-offerings-labels-main2']} key={item.id}>
            <div className={styles['revenue-offerings-labels-dot']} style={{ backgroundColor: item.color }} />
            <div className={styles['revenue-offerings-labels-label']}>{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RevenueByOfferings;

RevenueByOfferings.propTypes = {
  selectedValues: PropTypes.any.isRequired,
}